<template>
  <div>
    <b-row class="mb-5">
      <b-col cols="12">
        <div style="overflow:auto">
          <spinner v-if="activateSpinner"></spinner>
          <b-table v-else-if="listItemsEntityAccount.length > 0"
            :items="listItemsEntityAccount"
            :fields="fields"
            class="table-striped"
            hover
            :empty-text="$t('common.security.no_result')"
            style="margin-bottom:0"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDir"
            @head-clicked="sortTable"
            :key="refreshKey">
            <template #cell(StatusImportIban)="data">
              <span>{{ $t('common.entity_account.iban_import_status_' + data.value) }}</span>
              <span v-if="data.item.ProviderRejectionReason"
                    class="text-truncate"
                    :title="data.item.ProviderRejectionReason"
                    style="margin-left: 10px;">
                <b>{{ $t('common.entity_account.reason') }} : </b>
                {{ data.item.ProviderRejectionReason.length > 15
                    ? data.item.ProviderRejectionReason.substring(0, 15) + '...'
                    : data.item.ProviderRejectionReason }}
              </span>
            </template>
            <!-- <template #cell(StatusImportIban)="data">
              <f7-accordion-item class="accordionForm"
                                 v-if="['31', '32', '33'].includes(data.value)"
                                 :expanded="data.item.open"
                                 @accordion:open="data.item.open=true"
                                 @accordion:opened="data.item.openFinished=true;refreshKey = !refreshKey"
                                 @accordion:close="data.item.open=data.item.open=false"
                                 @accordion:closed="data.item.openFinished=false;refreshKey = !refreshKey">

                <f7-accordion-toggle class="accordionToggle">
                  <div class="form-group row justify-content-center">
                    <div class="col-sm-auto">
                      <span>{{ $t('common.entity_account.iban_import_status_' + data.value) }}</span>
                      <i class="ml-1 mt-1 fa-light fa-chevron-down color-var-actionButtonColorBlue"
                         v-if="data.item.open === true">
                      </i>
                      <i class="ml-1 fa-light fa-chevron-right color-var-actionButtonColorBlue"
                         v-else>
                      </i>
                    </div>
                  </div>
                </f7-accordion-toggle>

                <f7-accordion-content :class="{accordionContentExpended: data.item.openFinished}">
                  <div v-if="data.item.ProviderRejectionReason">
                    <span><b>{{ $t('common.entity_account.provider_rejection_reason') }} : </b>{{ data.item.ProviderRejectionReason }}</span>
                  </div>
                </f7-accordion-content>

              </f7-accordion-item>
              <span v-else>{{ $t('common.entity_account.iban_import_status_' + data.value) }}</span>
            </template> -->
            <template #cell(FileReference)="data">
              <span>{{ data.value }}</span>
            </template>
            <template #cell(DateAction)="data">
              <span>{{ getDate(data.value) }}</span>
            </template>
            <template #cell(Iban)="data">
              <span>{{ data.value }}</span>
            </template>
            <template #cell(Iban)="data">
              <span>{{ data.value }}</span>
            </template>
            <template #cell(IbanReference)="data">
              <span>{{ data.value }}</span>
            </template>
          </b-table>
          <div v-else class="d-flex justify-content-center">
            <span class="noResult">
              {{ $t('common.no_result') }}
            </span>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <cm-pagination
          :maxResultsByPage="paginationObject.maxResults"
          :firstIndex="paginationObject.firstIndex"
          :nbResultsTotal="paginationObject.nbResultsTotal"
          :refreshEvent="paginationObject.refresh">
        </cm-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import Pagination from '@/components/common/pagination.vue'
import moment from 'moment-timezone'
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"

export default {
  name: "EntityAccountList",
  components: {
    'cm-pagination': Pagination,
    "form-write-group-label-input": formWriteGroupLabelInput,
    "page-outline": PageOutline,
    spinner: Spinner
  },
  props: {
    id: {
      type: String,
      default: "-1",
    },
  },
  data() {
    return {
      activateSpinner: false,
      timezone: '+00:00',
      filterConditions: {},
      listItemsEntityAccount: [],
      listTitle: "",
      pageCounter: 0,
      paginationObject: {},
      refreshKey: false,
      sortBy: '',
      sortDir: false,
    }
  },
  created() {
    this.timezone = moment.tz.guess()
    
    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }

    this.listTitle = this.$i18n.t("common.entity_account.iban_history")
    // this.activateSpinner = true

    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.$bus.$off('apply-filters-entity')
    this.$bus.$on('apply-filters-entity', (filters) => {
      this.filterConditions = filters
      this.onRefresh()
    })

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.getEntityAccount(index)
      that.pageCounter = 0
    })

    // Événements pour contrôle depuis EntityAccountPage
    this.$bus.$off('refresh-entity-history')
    this.$bus.$on('refresh-entity-history', () => {
      this.onRefresh()
    })

    // Gestion des filtres depuis le parent
    this.$bus.$off('apply-filters-entity-history')
    this.$bus.$on('apply-filters-entity-history', (filters) => {
      this.filterConditions = filters
      this.onRefresh()
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0

    // this.getEntityAccount()

    if (this.id !== "-1") {
      this.tabName = parseInt(this.id)
    }
  },
  computed: {
    canDelete () {
      return true
    },
    canEdit () {
      return true
    },
    fields () {
      let fields = []
      fields.push({
        key: 'DateAction',
        label: this.$t('common.entity_account.date_action'),
        class: 'text-center',
        sortable: true
      })
      fields.push({
        key: 'StatusImportIban',
        label: this.$t('common.entity_account.iban_import_status'),
        class: 'text-center',
        sortable: true
      })
      fields.push({
        key: 'FileReference',
        label: this.$t('common.entity_account.file_reference'),
        class: 'text-center',
        sortable: true
      })
      fields.push({
        key: 'Iban',
        label: this.$t('common.entity_account.iban'),
        class: 'text-center',
        sortable: true
      })
      fields.push({
        key: 'IbanReference',
        label: this.$t('common.entity_account.iban_reference'),
        class: 'text-center',
        sortable: true
      })
      return fields
    }
  },
  methods: {
    applyFilter(filterConditions = {}) {
      this.filterConditions = filterConditions

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.getEntityAccount()
    },
    getEntityAccount(index = 1) {
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      let that = this
      let params = {
        IbanEncrypted: this.filterConditions.iban || '',
        IbanReference: this.filterConditions.ibanReference || '',
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex
      }
      if (this.filterConditions.OrderByField) {
        params.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        params.OrderByDirection = this.filterConditions.OrderByDirection
      }
      this.$engine.firstOn().entityAccount.getEntityAccount(params).then((resp) => {
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        that.paginationObject.nbResults = resp.data.EntityAccount.length

        let EntityAccountList = {}

        EntityAccountList = resp.data.EntityAccount

        that.updateEntityAccount(EntityAccountList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getDate (date) {
      if (!date) return '-';

      // Si la date ne contient pas un offset explicite (+00:00, +04:00, etc.) ou 'Z', on suppose qu'elle est en UTC
      const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(date);
      const isoWithTZ = hasTimezone ? date : date + 'Z';

      return moment(isoWithTZ).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss.SSS');
    },
    onRefresh() {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      this.getEntityAccount()
    },
    sortTable (key, field, event, isFooter) {
      const sortableFields = [
        'StatusImportIban',
        'FileReference',
        'DateAction'
      ]

      if (!sortableFields.includes(key)) {
        return
      }

      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    updateEntityAccount(EntityAccountList) {
      this.listItemsEntityAccount = EntityAccountList
    }
  }
}
</script>

<style scoped>
/* Fix table header contrast issues - remove all background images */
::v-deep .table th {
  background-color: #f8f9fa !important;
  background-image: none !important;
  color: #495057 !important;
  border-color: #dee2e6 !important;
}

::v-deep .table th[aria-sort] {
  background-color: #f8f9fa !important;
  background-image: none !important;
  color: #495057 !important;
  position: relative;
}

::v-deep .table th[aria-sort]::before,
::v-deep .table th[aria-sort]::after {
  background: none !important;
  background-image: none !important;
  color: #495057 !important;
  content: '' !important;
}

/* Remove any Bootstrap Vue sorting images */
::v-deep .table thead th.sortable {
  background-image: none !important;
  color: #495057 !important;
}

::v-deep .table thead th.sortable:hover {
  background-color: #e9ecef !important;
  background-image: none !important;
  color: #212529 !important;
}

/* Remove sorting indicator divs that might contain images */
::v-deep .table th div {
  background: transparent !important;
  background-image: none !important;
}
</style>
